'use client'

import * as GridLayout from '@/components/GridLayout/GridLayout'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { getStoryblokImageSize } from '@/services/storyblok/Storyblok.helpers'
import { storyblokEditable } from '@storyblok/react'
import { yStack } from 'ui/src/patterns/stack'
import { VINTAGE_SHOP_PRODUCT_LIST_BLOCK } from '../vintageShop.constants'
import type { VintageShopProductListBlockType, VintageShopProductTeaser } from '../vintageShop.types'
import { VintageShopProductList } from './VintageShopProductList/VintageShopProductList'

type Props = SbBaseBlockProps<VintageShopProductListBlockType>

export function VintageShopProductListBlock({ blok }: Props) {
  const teasers = mapProductsToTeasers(blok.products)

  return (
    <section className={yStack({ gap: 'xxxl', paddingBottom: 'xxxl' })} {...storyblokEditable(blok)}>
      <div className={yStack({ gap: 'xxxl', marginBottom: 'xxxl' })}>
        <GridLayout.Root>
          <GridLayout.Content width={{ _: '1' }} align="center">
            <VintageShopProductList teasers={teasers} />
          </GridLayout.Content>
        </GridLayout.Root>
      </div>
    </section>
  )
}

function mapProductsToTeasers(products: VintageShopProductListBlockType['products']): Array<VintageShopProductTeaser> {
  return products
    .filter((product) => typeof product !== 'string')
    .map((product) => {
      const imageSize = getStoryblokImageSize(product.content.startpageImage.filename)
      return {
        id: product.uuid,
        href: product.full_slug,
        heading: product.content.pageHeading,
        image: {
          src: product.content.startpageImage.filename,
          alt: product.content.startpageImage.alt ?? '',
          width: imageSize?.width ?? 1080,
          height: imageSize?.height ?? 1350,
        },
        fullWidthImage: product.content.startpageImageFullWidth?.filename
          ? {
              src: product.content.startpageImageFullWidth.filename,
              alt: product.content.startpageImageFullWidth.alt ?? '',
              width: getStoryblokImageSize(product.content.startpageImageFullWidth.filename)?.width ?? 2100,
              height: getStoryblokImageSize(product.content.startpageImageFullWidth.filename)?.height ?? 850,
            }
          : undefined,
        originalPrice: product.content.originalPrice,
        currentPrice: product.content.currentPrice,
        ourPrice: product.content.ourPrice,
        priceImage: product.content.priceImage?.filename ? { src: product.content.priceImage.filename } : undefined,
        priceIncrease: product.content.priceIncrease,
        isSold: product.content.isSold,
      }
    })
}

VintageShopProductListBlock.blockName = VINTAGE_SHOP_PRODUCT_LIST_BLOCK
